import React from 'react';
import Helmet from 'react-helmet';
import MediaSection from 'components/MediaSection/Loadable';
import SeparationLine from 'components/SeparationLine/SeparationLine';
import { useTranslation } from 'react-i18next';
import config from '../../config';

const About = () => {
  const styles = require('./About.scss');
  const SteveProfile = require('../../assets/steve-profile.jpg');
  const BensonProfile = require('../../assets/benson-profile.jpg');
  const { t } = useTranslation(['common', 'meta']);

  return (
    <div>
      <Helmet title={t('meta:META.ABOUT.TITLE')} />
      {/* eslint-disable max-len */}
      <Helmet
        meta={[
          {
            name: 'description',
            content: t('meta:META.ABOUT.DESCRIPTION')
          },
          { property: 'og:title', content: t('meta:META.ABOUT.TITLE') },
          {
            property: 'og:description',
            content: t('meta:META.ABOUT.DESCRIPTION')
          },
          { property: 'og:url', content: `${config.app.url}/about` },
          { id: 'english-canonical-url', content: '' }
        ]}
      />
      {/* eslint-enable */}

      {/* eslint-disable max-len */}
      <div
        className={styles.masthead}
        style={{
          background:
            'url("https://assets.ownrides.com/misc/paul-gilmore-231786.jpg")  center center / cover'
        }}
      >
        {/* eslint-enable */}
        <div className={styles.jumboHead}>
          <h1 className={styles.slogan}>
            Explore the world beyond your imagination
          </h1>
        </div>
      </div>
      <div>
        <div className={`${styles.content} container`}>
          <h1 className={styles.header}>About Us</h1>
          <div>
            <h2 className={`${styles.question} regular`}>OWNRIDES</h2>
            <div className={`${styles.listContainer} ${styles.quoteSection}`}>
              {/* eslint-disable max-len */}
              <p className={styles.answer}>
                OWNRIDES is an online driver booking platform for tourists. With
                a few simple steps, tourists can find and book a good private
                driver who drives safely, speaks the same language, and charges
                a fair price. OWNRIDES works with local partners to find the
                best private drivers for tourists. Only professional drivers who
                are licensed and have more than 5 years of driving experience
                are selected by OWNRIDES.
              </p>
              <h2 className={styles.quote}>
                Helping tourists travel around the world with the best private
                drivers as our mission
              </h2>
              {/* eslint-enable */}
            </div>
            <SeparationLine />

            <h2 className={`${styles.question} regular`}>Our Story</h2>
            <div className={styles.listContainer}>
              {/* eslint-disable max-len */}
              <p className={styles.answer}>
                Founded by a team of experienced entrepreneurs who have
                previously created products loved by millions of users, we are
                passionate about travel and have traveled the whole of Taiwan
                and much of Asia. Many times, we had to hire a private driver
                (charter a car) but had to spend a lot of time searching online
                and then contacting the drivers 1 by 1, asking their
                availability, pricing and other info. Even so, we could not be
                sure about the driver's driving skill, reliability and
                hospitality.
              </p>
              <p className={styles.answer}>
                Frustrated with this problem, we decided to create OWNRIDES to
                make finding and booking good private drivers simple, and made
                helping tourists travel around the world with the best private
                drivers as our mission.
              </p>
              <p className={styles.answer}>
                In 2020, the COVID-19 pandemic impacted us greatly. While many
                in the travel industry closed down, we stay relevant by helping
                more than 300 travelers (including the crew of EVA Air) book
                their &nbsp;
                <a
                  href="https://www.facebook.com/ownrides/posts/pfbid02EPWr2LcdQv5r833SZeSSfGpWLVio8Quuzk4YWpCHCKx6h3hz9i25u5NGWshSMn7hl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  quarantine hotels in Taiwan
                </a>
                , partnering with hotels in Taiwan and created the first online
                platform that makes finding and booking them easy.
              </p>
              {/* eslint-enable */}

              <div className={styles.profiles}>
                <span>
                  <img src={SteveProfile} alt="Steve Sng" />
                  <h5 className={styles.profileName}>Steve Sng</h5>
                  <p>CEO of OWNRIDES</p>
                </span>
                <span>
                  <img src={BensonProfile} alt="Benson Lu" />
                  <h5 className={styles.profileName}>Benson Lu</h5>
                  <p>CTO of OWNRIDES</p>
                </span>
              </div>
            </div>
            <SeparationLine />

            <h2 className={`${styles.question} regular`}>Our Values</h2>
            <div className={`${styles.listContainer} ${styles.quoteSection}`}>
              <h2 className={styles.quote}>
                We believe traveling is a good way to learn and grow
              </h2>
              {/* eslint-disable max-len */}
              <p className={styles.answer}>
                We believe traveling is a good way to learn and grow, especially
                through interaction with local people (such as our local
                drivers). Thus, as we build and grow OWNRIDES, we learn and grow
                with our customers and drivers too. Together, we help each other
                become better in whatever we are doing or want to do.
              </p>
              {/* eslint-enable */}
            </div>
          </div>
        </div>
        <SeparationLine />
        <MediaSection />
      </div>
    </div>
  );
};

export default About;
